import { Environments } from 'enum/Environments';

export const isProduction = () => (
  process.env.REACT_APP_ENV === Environments.PROD
);
